import { ChangeDetectionStrategy, Component, EventEmitter } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ColDef, ICellRendererParams } from '@ag-grid-community/core';
import { ProgressBarItem } from '@frontend-site/shared/data';

@Component({
    selector: 'multiple-progress-bar-renderer',
    template: `<p-multiple-progress-bar
        [values]="values"
        [displayTooltip]="displayTooltip"
        [linkLabelPart]="linkLabelPart"
        (linkClicked)="linkClicked.emit($event)"
    ></p-multiple-progress-bar>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultipleProgressBarRendererComponent implements ICellRendererAngularComp {
    values!: ProgressBarItem[];
    displayTooltip!: boolean;
    linkLabelPart!: number;
    linkClicked!: EventEmitter<void>;

    agInit(params: ICellRendererParams): void {
        this.extractParams(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.extractParams(params);
        return true;
    }

    private extractParams(params: ICellRendererParams): void {
        const data = (params.colDef as ColDef).cellRendererParams;
        const { buildValuesFunc, handleTooltip, linkLabelPart, linkClicked } = data || {};

        this.values = buildValuesFunc(params.node.data);
        this.displayTooltip = handleTooltip(params.node.data);
        this.linkLabelPart = linkLabelPart;
        this.linkClicked = linkClicked;
    }
}
